import { fetchReducerGenerator } from 'redpoints-front-common/reducers';

import {
  AUDIT_RESULTS_CLEAR,
  AUDIT_RESULTS_CLEAR_COMPLETED,
  AUDIT_RESULTS_FETCH_COMPLETED_AUDIT,
  AUDIT_RESULTS_FETCH_INCIDENTS_COMPARISON_REQUEST,
  AUDIT_RESULTS_SAVE_ASSET_AUDIT_REQUEST,
} from '../../../actions/actionTypes';

const completedAudit = fetchReducerGenerator(
  [
    AUDIT_RESULTS_CLEAR,
    AUDIT_RESULTS_CLEAR_COMPLETED,
    AUDIT_RESULTS_FETCH_INCIDENTS_COMPARISON_REQUEST,
    AUDIT_RESULTS_SAVE_ASSET_AUDIT_REQUEST,
  ],
  AUDIT_RESULTS_FETCH_COMPLETED_AUDIT
);

export default completedAudit;
